<template>
  <div class="kd-action-buttons">
    <kd-button
      text="Layout speichern"
      :icon="require('../assets/images/icons/check-1-white.svg')"
      size="big"
      type="secondary"
      @click.native="saveButtonClicked"
      style="margin-bottom: 12px"
    ></kd-button>
    <kd-button
      text="Änderungen verwerfen"
      :icon="require('../assets/images/icons/close.svg')"
      size="big"
      type="secondary"
      background-color="#DCDCDC"
      color="#333"
      @click.native="discardButtonClicked"
    ></kd-button>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import KdButton from '@/components/KdButton.vue';

// import {} from '@/store/getter-types';

import {
  SET_LAYOUT_MODE,
} from '@/store/mutation-types';

import {
  DISCARD_LAYOUT_CHANGES,
} from '@/store/action-types';

export default {
  computed: {
    // ...mapGetters([
    // ]),
  },
  methods: {
    ...mapMutations([
      SET_LAYOUT_MODE,
    ]),
    ...mapActions([
      DISCARD_LAYOUT_CHANGES,
    ]),
    saveButtonClicked() {
      this.SET_LAYOUT_MODE(false);
    },
    discardButtonClicked() {
      this.DISCARD_LAYOUT_CHANGES();
    },
  },
  components: {
    KdButton,
  },
};
</script>

<style lang="scss" scoped>
  .kd-action-buttons {
    position: absolute;
    // hach / oppermann-specific: the chat widget is overlaying the buttons, so we need to move them a bit up
    // bottom: 12px;
    bottom: 40px;
    right: 12px;
  }
</style>
